import { Font } from '@react-pdf/renderer';

/**
 * Registers the document font with react-pdf.
 *
 * Tinos is metric-compatible with Times New Roman. The browser loads the same
 * four TTF files through public/fonts/tinos.css, so text measured on screen and
 * the same text rendered to PDF have identical glyph widths and break into
 * identical lines. Both the Documents and Invoices PDFs use it.
 *
 * Importing this module registers the font. It is safe to import from several
 * PDF documents: react-pdf's font store is global and registering the same
 * family twice is a no-op.
 */

// react-pdf only fetches absolute URLs, so this resolves to the site origin in
// the browser and to a filesystem path when rendering from Node (tests).
export const PDF_ASSET_BASE =
  typeof window !== 'undefined' && window.location
    ? window.location.origin
    : (process.env.PUBLIC_URL || '');

/** Font family name to use in react-pdf styles. */
export const PDF_DOCUMENT_FONT = 'Tinos';

Font.register({
  family: PDF_DOCUMENT_FONT,
  fonts: [
    { src: `${PDF_ASSET_BASE}/fonts/Tinos-Regular.ttf` },
    { src: `${PDF_ASSET_BASE}/fonts/Tinos-Bold.ttf`, fontWeight: 'bold' },
    { src: `${PDF_ASSET_BASE}/fonts/Tinos-Italic.ttf`, fontStyle: 'italic' },
    { src: `${PDF_ASSET_BASE}/fonts/Tinos-BoldItalic.ttf`, fontWeight: 'bold', fontStyle: 'italic' },
  ],
});

// Browsers never hyphenate contenteditable text; react-pdf does by default.
// Disable it so a word that wraps in the editor also wraps here rather than
// being split with a hyphen.
Font.registerHyphenationCallback((word) => [word]);
